import { PAYSTACK_BASIC_CHARGE } from '../config/Payment';
// eslint-disable-next-line import/prefer-default-export
export const expectedAmount = (amountPaid, amountInc) => {
  return (
    ((amountPaid / 100 + amountInc) / (1 - `${PAYSTACK_BASIC_CHARGE}`)) * 100
  );
};
